// extracted by mini-css-extract-plugin
export var active = "_63-c";
export var activeIndicator = "_63-7";
export var animate = "_63-b";
export var contentWidthTabs = "_63-5";
export var disabled = "_63-d";
export var flat = "_63-1";
export var fullWidth = "_63-3";
export var lg = "_63-a";
export var md = "_63-9";
export var redoButtonTabGroup = "_63-0";
export var sm = "_63-8";
export var tabButton = "_63-4";
export var tabButtonsContainer = "_63-2";
export var xs = "_63-6";